import './topbar.scss';
import { useEffect, useRef, useState } from 'react';
import { useLayoutContext } from '../../context/game';
import { useClockContext } from '../../context/clock';
export default function Topbar({title,count}){
	const [context] = useLayoutContext();
	const [clock,setClock,start] = useClockContext();
	useEffect(()=>{
		if(!context?.hasStarted) return;
		if(clock?.passed >= 0) return;
		start();
	},[context])
	const [correctly,setCorrectly] = useState(0);

	useEffect(()=>{
		if(context.answered === null){ 
			setCorrectly(0);
			return
		};
		if(!context.answered) return;
		const correctArr = window['game_data']['answers'];
		const answeredIds = Object.keys(context.answered);
		let correct = 0;
		for(const questionId of answeredIds){
			const correctId = correctArr[questionId];
			const optionId = context.answered[questionId];
			if(correctId === optionId){
				correct++;
			}
		}
		setCorrectly(correct);
	},[context?.answered])
	const {disclaimer} = window.global_data || {};
	return(
		<div className="topbar">
			<div className="container">
				<h6 className="topbar-title mb-0">{title || 'Užduotis'}</h6>
				<hr />
				{!window['builder'] === true && context?.hasStarted && (
					<>
						<span className="clock-text">
							{clock?.text}
							<ClockIcon />
						</span>
						

						<div className="timeline" style={{height:8,borderRadius:100,background:'#E3E5E5',width:650,maxWidth:'100%'}}>
							<div className="timeline-passed" style={{borderRadius:100,height:'100%',background:'#2F8963',width:`${clock?.percent || 0}%`}}></div>
						</div>
						<hr />

						
						<span className='clock-text'>
							<CheckIcon />
							<span className="ms-3">
								{correctly}/{count}
							</span>
						</span>

					</>
				)}
			</div>
			{disclaimer && (
				<div className="topbar-text">
					<div className="container">
						{disclaimer}
					</div>
				</div>
			)}
		</div>
	)
}
function CheckIcon() {
	return <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M16.9999 33.6654C7.79492 33.6654 0.333252 26.2037 0.333252 16.9987C0.333252 7.7937 7.79492 0.332031 16.9999 0.332031C26.2049 0.332031 33.6666 7.7937 33.6666 16.9987C33.6666 26.2037 26.2049 33.6654 16.9999 33.6654ZM16.9999 30.332C20.5361 30.332 23.9275 28.9273 26.428 26.4268C28.9285 23.9263 30.3333 20.5349 30.3333 16.9987C30.3333 13.4625 28.9285 10.0711 26.428 7.57061C23.9275 5.07012 20.5361 3.66536 16.9999 3.66536C13.4637 3.66536 10.0723 5.07012 7.57183 7.57061C5.07134 10.0711 3.66659 13.4625 3.66659 16.9987C3.66659 20.5349 5.07134 23.9263 7.57183 26.4268C10.0723 28.9273 13.4637 30.332 16.9999 30.332ZM15.3383 23.6654L8.26659 16.5937L10.6233 14.237L15.3383 18.952L24.7649 9.5237L27.1233 11.8804L15.3383 23.6654Z" fill="#2F8963" />
	</svg>;
}

function ClockIcon() {
	return <svg className='mx-3' width="24" height="29" viewBox="0 0 24 29" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M19.4906 6.95603L21.4279 5.0187L23.3133 6.90403L21.3759 8.84136C23.2903 11.2376 24.2145 14.2759 23.9587 17.3322C23.7029 20.3886 22.2866 23.231 20.0006 25.2757C17.7146 27.3204 14.7324 28.4122 11.6666 28.3268C8.60072 28.2415 5.68393 26.9855 3.51521 24.8167C1.3465 22.648 0.0904876 19.7312 0.00514006 16.6654C-0.0802075 13.5995 1.01158 10.6174 3.05629 8.33138C5.10099 6.04537 7.9434 4.62903 10.9997 4.37326C14.0561 4.11748 17.0944 5.04167 19.4906 6.95603ZM11.9999 25.6654C13.2256 25.6654 14.4393 25.424 15.5716 24.9549C16.704 24.4859 17.7329 23.7984 18.5996 22.9317C19.4663 22.065 20.1537 21.0361 20.6228 19.9037C21.0918 18.7714 21.3333 17.5577 21.3333 16.332C21.3333 15.1064 21.0918 13.8927 20.6228 12.7603C20.1537 11.6279 19.4663 10.599 18.5996 9.73237C17.7329 8.86569 16.704 8.1782 15.5716 7.70916C14.4393 7.24011 13.2256 6.9987 11.9999 6.9987C9.52456 6.9987 7.15059 7.98203 5.40025 9.73237C3.64991 11.4827 2.66658 13.8567 2.66658 16.332C2.66658 18.8074 3.64991 21.1814 5.40025 22.9317C7.15059 24.682 9.52456 25.6654 11.9999 25.6654ZM10.6666 9.66537H13.3333V17.6654H10.6666V9.66537ZM6.66658 0.332031H17.3333V2.9987H6.66658V0.332031Z" fill="#2F8963" />
	</svg>;
}

